import { FC } from 'react';

import { trackDropdownInputUsageAnalyticsEvent } from 'analytics/events/input-usage';

import {
  FieldErrors,
  FieldValues,
  UseFieldArrayRemove,
  UseFieldArrayUpdate
} from 'react-hook-form';

import Patient from 'models/Patient';

import OperatorCreateTicketInfoFormItem from './OperatorCreateTicketInfoFormItem';
import { TicketFormField } from './ticket.shared';

const generateUniqueKey = (selectedTicketType: TicketFormField) => {
  const { parentId, ticketSubTypeIds } = selectedTicketType;
  const subTypesKey = ticketSubTypeIds?.length ? ticketSubTypeIds.join('_') : '_';
  return `${parentId}_${subTypesKey}`;
};

export const SelectedOperatorCreateTicketInfoFormItem: FC<{
  selectedTicketType: TicketFormField & { id: string };
  index: number;
  tickets: TicketFormField[];
  remove: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<FieldValues, 'tickets'>;
  patient: Patient;
  errors: FieldErrors<FieldValues>;
}> = ({ selectedTicketType, index, tickets, remove, update, patient, errors }) => {
  const internalId = generateUniqueKey(selectedTicketType);
  const { id } = selectedTicketType;
  const fieldName = `tickets[${index}]`;

  const ticketError = (errors.tickets as Record<string, any> | undefined)?.[id] || {};

  // Get the latest ticket data using index from tickets array
  const latestTicketData = tickets[index] || selectedTicketType;

  return (
    <OperatorCreateTicketInfoFormItem
      testHook={`operator-create-ticket-item-${internalId}`}
      fieldName={fieldName}
      errors={ticketError}
      patient={patient}
      categoryId={latestTicketData.categoryId}
      // Get the latest ticketSubTypeIds from the watched tickets array
      ticketSubTypeIds={latestTicketData.ticketSubTypeIds}
      onDropdownChange={trackDropdownInputUsageAnalyticsEvent}
      removeDynamicFormTickets={remove}
      updateDynamicFormTickets={update}
    />
  );
};
